export const Loading = () => {
  return <div className="loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
}